import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="auto-submit"
export default class extends Controller {
  submitForm(event) {
    const {currentTarget: form} = event;

    form.requestSubmit()
  }
}
